module.exports = __webpack_public_path__ + "static/media/prev-page.1b53e0e3.svg";